/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./accountMgmtAnnouncement.vue?vue&type=template&id=b6f48478"
import script from "./accountMgmtAnnouncement.vue?vue&type=script&lang=js"
export * from "./accountMgmtAnnouncement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports